import React from 'react'
import Table from '../../components/Table'
export default () => (
  <Table />
)